import React from 'react';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppContext, emptyContext } from 'app/context/app-context';
import { AppContextProps } from 'app/context/app-context-props';
import { AppConfigName } from 'app/enum/app-config-name';
import { appConfigService } from 'app/services/app-config.service';

export class AppContextProvider extends React.Component<unknown, { appContext: AppContextProps }> {
    private subscription?: Subscription;

    public constructor(props: Readonly<unknown>) {
        super(props);

        this.state = {
            appContext: emptyContext,
        };
    }

    public componentDidMount(): void {
        this.subscription = AppContextProvider.buildContext().subscribe((newContext) =>
            this.setState({ appContext: newContext }),
        );
    }

    public componentWillUnmount(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public render(): React.ReactNode {
        return <AppContext.Provider value={this.state.appContext}>{this.props.children}</AppContext.Provider>;
    }

    private static buildContext(): Observable<AppContextProps> {
        return appConfigService.listAll().pipe(
            map((configs) => {
                const contextProps: AppContextProps = emptyContext;
                configs.forEach((config) => {
                    if (config.name === AppConfigName.CHANNEL_METHOD || config.name === AppConfigName.MATCH_METHOD) {
                        config.value = AppContextProvider.flipRecord(config.value as Record<string, number>);
                    }
                    contextProps.appConfigs[config.name] = config;
                });

                return contextProps;
            }),
        );
    }

    private static flipRecord<K extends number | string, V extends number | string>(data: Record<K, V>): Record<V, K> {
        const ret = {} as Record<V, K>;
        Object.keys(data).forEach((key) => {
            ret[data[key as unknown as K] as V] = key as unknown as K;
        });

        return ret;
    }
}
